import axios from "axios";
import axiosInstance from "../../../api/Axios";

export const uploadFileCourse = async (
  file,
  type = "course",
  token,
  passId = false,
  course_id = null
) => {
  const fileObj = { filename: file.name, type };
  const IdFileObj = { filename: file.name, type, course_id };
  const payload = passId ? IdFileObj : fileObj;
  try {
    let res = await axiosInstance.post("/uploadurl/", payload, {
      headers: {
        "X-CSRFToken": token,
      },
    });
    console.log(payload, res, file, "payload");
    await axios.put(res?.data?.url, file);
    return res?.data?.filename;
  } catch (err) {
    console.log(err);
  }
};
export const uploadFileCourseLMS = async (payload, token) => {
  try {
    let res = await axiosInstance.post("/uploadurl/", payload, {
      headers: {
        "X-CSRFToken": token,
      },
    });
    console.log(payload, "payload");
    await axios.put(res?.data?.url, payload?.file, {
      headers: {
        "Content-Type": res?.data?.content_type,
      },
    });
    return res?.data?.filename;
  } catch (err) {
    console.log(err);
  }
};
export const modifyFileName = (fileName) => {
  return fileName?.replace(/\d{10}(\.\w+)$/, "$1");
};

export const getCleanFileName = (filePath = "") => {
  const fullName = filePath.split("/").pop(); // take last part after '/'
  const ext = fullName.split(".").pop(); // extension
  const base = fullName.replace(`.${ext}`, ""); // without extension

  // remove trailing numbers (like timestamp)
  const cleanedBase = base.replace(/\d+$/, "");

  return `${cleanedBase}.${ext}`;
};

export const getFileType = (filePath = "", commonName = false) => {
  if (!filePath) return "unknown";

  const fullName = filePath.split("/").pop() || "";
  const ext = fullName.includes(".")
    ? fullName.split(".").pop().toLowerCase()
    : "";

  if (!ext) return "unknown";

  if (!commonName) {
    return ext; // return raw extension like mp4, png, pdf
  }

  const videoTypes = ["mp4", "webm", "ogg", "mov", "avi", "mkv"];
  const imageTypes = ["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"];
  const audioTypes = ["mp3", "wav", "aac", "flac", "m4a"];
  const documentTypes = [
    "pdf",
    "doc",
    "docx",
    "ppt",
    "pptx",
    "xls",
    "xlsx",
    "txt",
  ];

  if (videoTypes.includes(ext)) return "video";
  if (imageTypes.includes(ext)) return "image";
  if (audioTypes.includes(ext)) return "audio";
  if (documentTypes.includes(ext)) return "document";

  return "other";
};

export const getFileTypeColor = (fileUrl) => {
  const type = fileUrl ? getFileType(fileUrl, true) : "unknown";

  const typeColors = {
    document: "red",
    image: "green",
    video: "purple",
    other: "black",
    unknown: "gray",
  };

  return typeColors[type] || typeColors.other;
};
export function formatTypeText(text) {
  if (!text) return "";
  // Replace underscores with spaces, lowercase everything, then capitalize each word
  return text
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
